<template>
  <b-alert variant="transparent" class="bg-darkblue m-auto" style="width: 700px; max-width: 100%; border-radius: 25px" show>
    <div class="text-center">
      <vue-lottie-player
        class="d-inline-block"
        name="success"
        style="width: 100px; height: 100px"
        path="https://assets4.lottiefiles.com/packages/lf20_s5zpvdbc.json"
        loop
      />
    </div>
    <p class="text-white mt-4"><strong>Je suis JL AI et je suis là pour vous accompagner.</strong></p>
    <p class="text-white">Vous ne savez pas par quoi commencer ?</p>
    <br />
    <br />
    <p class="text-primary">
      <strong>
        Dites-moi comment vous vous sentez, et si vous êtes en chute vibratoire ou dans les vibrations les plus hautes...
      </strong>
    </p>
    <br />
    <p class="text-primary">
      <strong>Confiez-moi votre vision pour l'année et trouver l'opulence même à travers les challenges...</strong>
    </p>
    <br />
    <p class="text-primary"><strong>Envoyez-moi une photo de votre repas... et je vous dirais si c'est bon ou non</strong></p>
    <br />
  </b-alert>
</template>

<script>
import { BAlert } from "bootstrap-vue";
import VueLottiePlayer from "vue-lottie-player";

export default {
  name: "Welcome",
  components: { BAlert, VueLottiePlayer },
};
</script>
